import { logError } from '@hotjar/insights-common/lib/logger';
import type { IconName } from '@hotjar/hotsauce';
import { UserAttributeKind } from '../../../../domains/user-attributes/model/UserAttribute';

const getUnknownMetaData = (never: never): IconName => {
  logError(new Error(`Unknown Filter kind (We shouldn't reach this part): ${never}`));
  return 'warning';
};

export const getIconName = (kind: UserAttributeKind): IconName => {
  switch (kind) {
    case UserAttributeKind.Number:
      return 'number';
    case UserAttributeKind.String:
      return 'string';
    case UserAttributeKind.Email:
      return 'string';
    case UserAttributeKind.Boolean:
      return 'boolean';
    case UserAttributeKind.Date:
      return 'date';
    case UserAttributeKind.Unknown:
      return 'warning';
    default:
      return getUnknownMetaData(kind);
  }
};

// The 'user_id' UA is a special snowflake. It is stored in Elasticsearch as just a keyword (without ngrams)
// so we cannot do "contains", "starts with" and "ends with" operations with queries.
const USER_ID_USER_ATTRIBUTE = 'user_id';

export const isUserId = (userAttributeName?: string): boolean => {
  return USER_ID_USER_ATTRIBUTE === userAttributeName;
};
